import { gql } from '@apollo/client'

const CREATE_TEMPLATE_GOALS = gql`
  mutation createTemplateGoals($nonprofitOrgId: Int!, $templateIds: [Int!]!) {
    createTemplateGoals(
      nonprofitOrgId: $nonprofitOrgId
      templateIds: $templateIds
    ) {
      goals {
        id
        type
        templateLibraryId
        title
      }
    }
  }
`

export default CREATE_TEMPLATE_GOALS
